import { useSearchParams } from '@occc-app/hooks/useSearchParams';

import { RetailerNetworkLocationsAndGroupsTab } from './retailer-network-locations-configuration.types';

const LOCATIONS_PREFIX = 'locations';

export const LOCATIONS_BEFORE_PARAM = `${LOCATIONS_PREFIX}-before`;
export const LOCATIONS_AFTER_PARAM = `${LOCATIONS_PREFIX}-after`;

export const LOCATIONS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${LOCATIONS_PREFIX}-search`,
  afterParamName: LOCATIONS_AFTER_PARAM,
  beforeParamName: LOCATIONS_BEFORE_PARAM,
};

const LOCATION_GROUPS_PREFIX = 'locationGroups';

export const LOCATION_GROUPS_BEFORE_PARAM = `${LOCATION_GROUPS_PREFIX}-before`;
export const LOCATION_GROUPS_AFTER_PARAM = `${LOCATION_GROUPS_PREFIX}-after`;

export const LOCATION_GROUPS_PARAM_NAMES: Parameters<typeof useSearchParams>[0] = {
  searchParamName: `${LOCATION_GROUPS_PREFIX}-search`,
  afterParamName: LOCATION_GROUPS_AFTER_PARAM,
  beforeParamName: LOCATION_GROUPS_BEFORE_PARAM,
};

export const RETAILER_NETWORK_LOCATIONS_AND_GROUPS_TAB_PARAM = 'tab';
export const DEFAULT_RETAILER_NETWORK_LOCATIONS_AND_GROUPS_TAB: RetailerNetworkLocationsAndGroupsTab =
  'locations';
export const RETAILER_NETWORK_LOCATIONS_AND_GROUPS_TABS: RetailerNetworkLocationsAndGroupsTab[] = [
  'locations',
  'groups',
];
export const tabLabelsMap: Record<RetailerNetworkLocationsAndGroupsTab, string> = {
  locations: 'All Locations',
  groups: 'Location Groups',
};
